import Vue from "vue";
import Vuex from "vuex";
import EquipmentsStore from "./modules/equipment.store";
import GlobalAppDataStore from "./modules/globalAppData.store";
import SettingsStore from "./modules/settings.store";
import SiteStore from "./modules/site.store";
import { StatisticsState } from "@/store/modules/statisticsState";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    siteModule: SiteStore,
    globalAppDataModule: GlobalAppDataStore,
    settingsModule: SettingsStore,
    equipmentsModule: EquipmentsStore,
    statisticsState: StatisticsState,
  },
});

export default store;
